import React from "react";
import css from "./Connection.scss";
import commonWidgetCSS from "./CommonWidget.css";
import PropTypes from "prop-types";
import Icon from "../SF/MaterialIcon";
import { imageStyle } from 'utils/images';
import { SFEntityID } from 'utils/types';
import {getStaffMemberConnectionProfileUrl, getStaffMemberSchedulingUrl} from "../utils/successNetworkURL";

const getEmail = (email) => {
    if (!email) return null;
    return (
        <div className={css.row} data-testid='email'>
            <Icon aria-hidden="true" icon='email'/>
            <a href={`mailto:${email}`}>{email}</a>
        </div>
    );
}

const getPhone = (phone) => {
    if (!phone) return null;
    return (
        <div className={css.row} data-testid='phone'>
            <Icon aria-hidden="true" icon='phone'/>
            <span className={css.text}>{phone}</span>
        </div>
    );
}

const getFooter = (footerProps) =>
  (
    <div className={css.footer}>
      <div>
        {footerProps.onlineSchedulingAvailable && <a href={getStaffMemberSchedulingUrl(footerProps.personId)}>SCHEDULE</a>}
        {footerProps.phoneNumber && <a href={`tel:${footerProps.phoneNumber}`}>CALL</a>}
      </div>
    </div>
  )

const Connection = (props) => {
    return (
        <div className={`${css.contentInner} ${commonWidgetCSS.container}`}data-role={props.fullName}>
            <div className={css.contentInnerChild}>
                <div className={css.image} style={imageStyle(props.uuid, props.photoAvailable)}/>
                <div className={css.info}>
                    <div className={css.name}>
                        <a href={getStaffMemberConnectionProfileUrl(props.personId)} className={css['link']}>
                            {props.fullName}
                        </a>
                    </div>
                    <div className={css.title} data-testid='connectionTitle'>
                        {props.title ? props.title : props.roles.join(', ')}
                    </div>
                    {getEmail(props.email)}
                    {getPhone(props.phoneNumber)}
                </div>
            </div>
            {getFooter(props)}
        </div>);
};

Connection.propTypes = {
    personId: SFEntityID.isRequired,
    uuid: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    roles: PropTypes.array.isRequired,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    onlineSchedulingAvailable: PropTypes.bool,
    photoAvailable: PropTypes.bool,
    title: PropTypes.string,
    upward: PropTypes.bool
};

export default Connection;
